import { render, staticRenderFns } from "./PartnersSlider.vue?vue&type=template&id=68f1e2bb&"
import script from "./PartnersSlider.vue?vue&type=script&lang=js&"
export * from "./PartnersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports